import axios from '../../config/axios';
import axios2 from 'axios';

import config from '../../config/api';
import { setSnackbar } from './SnackbarAction';

export const getAllRegisters = (data) => ({
    type: 'GET_REGISTERS',
    data
})

export const getRegisterData = (data) => ({
    type: 'GET_REGISTER_DATA',
    data
})

export const getFilteredData = (data) => ({
    type: 'FILTER_REGISTERS',
    data
})

export const getRegisterFee = (data) => ({
    type: 'GET_REGISTER_FEE',
    data
})

export const setRegisterEdit = (data) => ({
    type: 'SET_EDIT',
    data
})

export const setRegisterID = (data) => ({
    type: 'SET_REGISTER_ID',
    data
})

export const setClone = (data) => ({
    type: 'SET_CLONE_REGISTER',
    data
})


export const setModifiedRegister = (data) => ({
    type: 'SET_MODIFIED_REGISTER',
    data
})

export const setRegistertickets = (data) => ({
    type: 'SET_REGISTER_TICKETS',
    data
})

export const setOpenTicket = (data) => ({
    type: 'SET_TICKET_RESPONSE',
    data
})

export const setOpenTicketStatus = (data) => ({
    type: 'SET_TICKET_STATUS',
    data
})


export const setTransactionResponse = (data) => ({
    type: 'SET_TRANSACTION_RESPONSE',
    data
})

export const setFeeDetails = (data) => ({
    type: 'SET_FEE_DETAILS',
    data
})




export const fetchAllRegisters = () => {
    return function (dispatch) {
        dispatch(getAllRegisters([]));
        axios.get(`${config.api.FETCH_URL}/register/getAllRegisters`).then(response => {
            if (response.status === 200) {
                dispatch(getAllRegisters(response.data));
            } else {
                dispatch(getAllRegisters([]));
            }
        }).catch(error => {
            dispatch(getAllRegisters([]));
        })
    }
}

export const fetchRegisterID = (registerID) => {
    return function (dispatch) {
        dispatch(getRegisterData([]));
        axios.get(`${config.api.FETCH_URL}/register/getRegisterData/${registerID}`).then(response => {
            if (response.status === 200) {
                dispatch(getRegisterData([response.data]));
            } else {
                dispatch(setSnackbar(true, 'error', 'Register ID is not present'))
                dispatch(getRegisterData([]));

            }
        }).catch(error => {
            dispatch(setSnackbar(true, 'error', 'Register ID entered is not present'))
            dispatch(getRegisterData([]));
        })
    }
}

export const fetchRegisterFee = (registerID) => {
    return function (dispatch) {
        dispatch(getRegisterFee([]));
        axios.get(`${config.api.FETCH_URL}/register/getRegisterFee/${registerID}`).then(response => {
            if (response.status === 200) {
                dispatch(getRegisterFee([response.data]));
            } else {
                dispatch(getRegisterFee([]));
            }
        }).catch(error => {
            dispatch(getRegisterFee([]));
        })
    }
}

export const editRegisterFee = (body) => {
    return function (dispatch) {
        const token = sessionStorage.getItem('user') ? 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).token : '';
        axios.post(`${config.api.FETCH_URL}/register/addRegisterFee`, body, {
            headers: { 'Authorization': token }
        }).then(response => {
            if (response.status === 200) {
                dispatch(setSnackbar(true, 'success', 'Register Fee Updated'))
                dispatch(fetchRegisterFee(body.registerID))
            } else {
                dispatch(setSnackbar(true, 'error', 'Something Went Wrong'))
            }
        }).catch(error => {
            dispatch(setSnackbar(true, 'error', 'Something Went Wrong'))
        })
    }
}

export const fetchMerchantRegisters = (merchantID) => {
    return function (dispatch) {
        dispatch(getAllRegisters([]));
        axios.get(`${config.api.FETCH_URL}/register/getAllRegistersByMerchantID/${merchantID}`).then(response => {
            if (response.status === 200) {
                dispatch(getAllRegisters(response.data));
            } else {
                dispatch(getAllRegisters([]));
            }
        }).catch(error => {
            dispatch(getAllRegisters([]));
        })
    }
}

export const addRegister = (body) => {
    return function (dispatch) {
        axios.post(`${config.api.FETCH_URL}/register/addRegister`, body).then(response => {
            if (response.status === 200) {
                dispatch(setModifiedRegister(true))
                console.log(response.data.registerID)
                dispatch(setRegisterID(response.data.registerID))
                dispatch(setSnackbar(true, 'success', 'Register Added'))
            } else {
                dispatch(setSnackbar(true, 'error', 'Something Went Wrong'))
            }
        }).catch(error => {
            dispatch(setSnackbar(true, 'error', 'Something Went Wrong'))
        })
    }
}

export const editRegister = (body) => {
    return function (dispatch) {
        axios.put(`${config.api.FETCH_URL}/register/editRegister`, body).then(response => {
            if (response.status === 200) {
                dispatch(setModifiedRegister(true))
                dispatch(setRegisterID(response.data.registerID))
                dispatch(setSnackbar(true, 'success', 'Register Updated'))
            } else {
                dispatch(setSnackbar(true, 'error', 'Something Went Wrong'))
            }
        }).catch(error => {
            dispatch(setSnackbar(true, 'error', 'Something Went Wrong'))
        })
    }
}

export const filteredData = (data) => {
    return function (dispatch) {
        dispatch(getFilteredData(data))
    }
}

export const refreshToken = (registerID) => {
    return function (dispatch) {
        axios.put(`${config.api.FETCH_URL}/register/refreshToken`, registerID).then(response => {   

     })
    }
}

export const fetchRegistertickets = (registerID) => {
    return function (dispatch) {
        dispatch(setRegistertickets([]));
        axios.get(`${config.api.FETCH_URL}/register/getAllRegisterTickets/${registerID}`).then(response => {
            if (response.status === 200) {
                console.log('API reposne for tickets : ', response.data)
                dispatch(setRegistertickets(response.data));
            } else {
                dispatch(setRegistertickets([]));
            }
        }).catch(error => {
            dispatch(setRegistertickets([]));
        })
    }
}

export const calculateFee = (body, accessToken) => {
    return function (dispatch) {
        dispatch(setFeeDetails(null));
        axios2.post(`${config.api.POS_SYSTEM_URL}/posSystem/calculateFee/`, body, {
            headers: { 'Authorization': `Token ${accessToken}` }
        }).then(response => {
            if (response.status === 200) {
                dispatch(setFeeDetails(response.data));
            } else {
                dispatch(setSnackbar(true, 'error', 'Unable to calculate fee'))
                dispatch(setFeeDetails(null));
            }
        }).catch(error => {
            dispatch(setSnackbar(true, 'error', 'Unable to calculate fee'))
            dispatch(setFeeDetails(null));
        })
    }
}

export const openTicket = (body, accessToken) => {
    return function (dispatch) {
        dispatch(setOpenTicket([]));
        axios2.post(`${config.api.POS_SYSTEM_URL}/posSystem/openTicket/`, body,{ headers: {
            'Authorization': `Token ${accessToken}`}
          }).then(response => {
            if (response.status === 200) {
                dispatch(setOpenTicket(response.data));
                dispatch(fetchRegistertickets(body.registerId))
                if(response.data.ticketStatus === 'Opened'){
                    dispatch(setOpenTicketStatus(true))
                }else {
                    dispatch(setOpenTicketStatus(false))

                }
            } else {
                dispatch(setOpenTicket([]));
            }
        }).catch(error => {
            dispatch(setOpenTicket([]));
        })
    }
}


export const transactionStatus = (body, accessToken) => {
    return function (dispatch) {
        setTransactionResponse(null);
        axios2.post(`${config.api.POS_SYSTEM_URL}/posSystem/getTransactionStatus/`, body,{ headers: {
            'Authorization': `Token ${accessToken}`}
          }).then(response => {
            if (response.status === 200) {
                dispatch(setTransactionResponse(response.data));
            } else {
                dispatch(setTransactionResponse([]));
            }
        }).catch(error => {
            dispatch(setTransactionResponse([]));
        })
    }
}

